<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <template v-if="labelShow">
        <breadcrumbSourcing
          :breadcrumb-data="breadcrumbData"
        ></breadcrumbSourcing>
        <!--      <div class="detail-info-el-Label">-->
        <!--        <el-label :type="labelType" style="height: 100px;"></el-label>-->
        <!--      </div>-->
      </template>
      <div class="ccui-app-iframe-container-detail">
        <div class="ccui-app-iframe-container-detail-body">
          <el-tabs class="el-tabs__customize" value="1">
            <el-tab-pane label="评标报告" name="1">
              <el-button
                class="sure-btn"
                v-preventReClick
                v-if="
                  editFlag || form.reportStatus == 0 || form.reportStatus == 1
                "
                icon="icon-ccui-agree"
                style="position: absolute;right: 0;"
                @click="dealBidReportSubmit"
                >提交确认</el-button
              >
              <div class="pdf-btn">
                <el-button type="single-number" @click="getReportFileUrl"
                  >AI评标报告导出</el-button
                >
              </div>

              <el-form :model="form" ref="form" label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="项目编号：" prop="projectCode">
                      <span>{{ form.projectCode }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="项目名称：" prop="projectName">
                      <span>{{ form.projectName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="编制人：" prop="agentName">
                      <span>{{ form.agentName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <template v-if="editFlag">
                  <el-row>
                    <el-col :span="20">
                      <el-form-item label="评审总结：" prop="textInfo">
                        <el-input
                          v-model="form.textInfo"
                          placeholder="请输入评审总结"
                          type="textarea"
                          maxlength="500"
                          show-word-limit
                          :rows="4"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-else>
                  <el-row>
                    <el-col :span="20">
                      <el-form-item label="评审总结：" prop="textInfo">
                        <span>{{ form.textInfo }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </el-form>
            </el-tab-pane>
          </el-tabs>
          <el-tabs class="el-tabs__customize" v-model="active">
            <el-tab-pane label="推荐表" name="1">
              <el-table
                :data="recommendationTableData"
                border
                :span-method="objectSpanMethodRecommendation"
              >
                <el-table-column
                  prop="id"
                  label="序号"
                  width="55"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="packName"
                  label="包件名称"
                  min-width="250"
                  show-overflow-tooltip
                  v-if="subPackageFlag"
                ></el-table-column>
                <el-table-column
                  prop="supName"
                  label="供应商名称"
                  width="250"
                  show-overflow-tooltip
                ></el-table-column>
                <template v-if="evaMethod === '102'">
                  <el-table-column
                    prop="techSumScore"
                    label="技术汇总得分"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="busiSumScore"
                    label="商务汇总得分"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="sumScore"
                    label="汇总得分"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <a
                        class="link-color"
                        href="javascript:void (0)"
                        @click="goDetail(scope.row)"
                        >{{ scope.row.sumScore }}</a
                      >
                    </template>
                  </el-table-column>
                </template>
                <el-table-column
                  prop="priceAmount"
                  :label="baojiaName"
                  width="200"
                  show-overflow-tooltip
                  v-if="purchaseType !== '50' && purchaseType !== '53'"
                >
                  <template slot-scope="{ row }">
                    <span>{{
                      row.priceAmount
                        ? new BigNumber(row.priceAmount).toFormat(2)
                        : ""
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="recommendFlag"
                  label="是否推荐"
                  width="122"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <template v-if="editFlag">
                      <el-select
                        v-model="row.recommendFlag"
                        style="width: 105px;"
                      >
                        <el-option label="推荐" value="1">推荐</el-option>
                        <el-option label="不推荐" value="0">不推荐</el-option>
                      </el-select>
                    </template>
                    <template v-else>{{ row.recommendFlagStr }}</template>
                  </template>
                </el-table-column>
                <template v-if="evaMethod === '102'">
                  <el-table-column
                    prop="reason"
                    label="说明"
                    show-overflow-tooltip
                    width="250"
                  >
                    <template slot-scope="{ row }">
                      <template v-if="editFlag">
                        <el-input
                          maxlength="500"
                          show-word-limit
                          class="input-short word-limit input-width;"
                          v-model="row.reason"
                          type="textarea"
                          placeholder="请输入说明"
                        ></el-input>
                      </template>
                      <template v-else>
                        {{ row.reason }}
                      </template>
                    </template>
                  </el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                    prop="reason"
                    label="说明"
                    show-overflow-tooltip
                  >
                    <template slot-scope="{ row }">
                      <template v-if="editFlag">
                        <el-input
                          maxlength="500"
                          show-word-limit
                          class="input-short word-limit input-width;"
                          v-model="row.reason"
                          type="textarea"
                          placeholder="请输入说明"
                        ></el-input>
                      </template>
                      <template v-else>
                        {{ row.reason }}
                      </template>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="评标报告手签版" name="2">
              <template v-if="editFlag">
                <div class="fr">
                  <el-upload
                    class="upload-demo tow"
                    :action="uploadForm.action"
                    :on-progress="onProgress"
                    :on-success="uploadSuccess"
                    accept=".docx,.pdf"
                    :on-error="handleErrorReport"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :on-change="uploadChange"
                    :data="formData"
                  >
                    <span style="color: red"
                      >只能上传word文档或pdf文档且文档个数限制为一个</span
                    >
                    <el-button plain type="single-number">上传附件</el-button>
                  </el-upload>
                </div>
              </template>
              <el-table :data="bidEvaluationReportTableData" border>
                <el-table-column type="index" label="序号" width="55" />
                <el-table-column
                  prop="fileName"
                  label="附件名称"
                  :render-header="addRedStar"
                  show-overflow-tooltip
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="fileSize"
                  label="附件大小"
                  :render-header="addRedStar"
                  width="180"
                >
                  <template slot-scope="{ row }">
                    <span>{{ row.fileSize }}k</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSumm"
                  label="附件说明"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <template v-if="editFlag">
                      <el-input
                        maxlength="500"
                        show-word-limit
                        class="input-short word-limit input-width;"
                        placeholder="请输入附件说明"
                        v-model="row.fileSumm"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span>{{ row.fileSumm }}</span>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="上传时间"
                  width="170"
                ></el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="{ row, $index }">
                    <template v-if="editFlag">
                      <el-button type="text" @click="deleteFile($index, 0)"
                        >删除</el-button
                      >
                    </template>
                    <el-button type="text" @click="download(row)"
                      >下载</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="其他附件" name="3">
              <template v-if="editFlag">
                <div class="fr">
                  <el-upload
                    class="upload-demo tow"
                    :on-change="uploadChange"
                    :action="uploadForm.action"
                    :before-upload="beforeAvatarUpload"
                    :on-error="uploadError"
                    :on-success="uploadOtherFileSuccess"
                    :on-progress="onProgress"
                    :show-file-list="false"
                    :data="formData"
                    multiple
                  >
                    <el-button plain type="single-number">上传附件</el-button>
                  </el-upload>
                </div>
              </template>
              <el-table :data="otherFileTableData" border>
                <el-table-column type="index" label="序号" width="55" />
                <el-table-column
                  prop="fileName"
                  label="附件名称"
                  show-overflow-tooltip
                  width="180"
                ></el-table-column>
                <el-table-column prop="fileSize" label="附件大小" width="180">
                  <template slot-scope="{ row }">
                    <span>{{ row.fileSize }}K</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="fileSumm"
                  label="附件说明"
                  show-overflow-tooltip
                >
                  <template slot-scope="{ row }">
                    <template v-if="editFlag">
                      <el-input
                        maxlength="500"
                        show-word-limit
                        class="input-short word-limit input-width;"
                        placeholder="请输入附件说明"
                        v-model="row.fileSumm"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span>{{ row.fileSumm }}</span>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="上传时间"
                  width="170"
                ></el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="{ row, $index }">
                    <template v-if="editFlag">
                      <el-button type="text" @click="deleteFile($index, 1)"
                        >删除</el-button
                      >
                    </template>
                    <el-button type="text" @click="download(row)"
                      >下载</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <template v-if="!editFlag">
              <el-tab-pane label="专家确认记录" name="4">
                <el-table
                  :data="expertTableData"
                  border
                  :span-method="objectSpanMethodResult"
                >
                  <el-table-column
                    prop="round"
                    label="确认轮次"
                    width="100"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="id"
                    label="序号"
                    width="55"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="expertName"
                    label="专家姓名"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmResultStr"
                    label="确认结果"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmOpinion"
                    label="确认意见"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmTime"
                    label="确认日期"
                    width="170"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="confirmStatusStr"
                    label="确认状态"
                    width="120"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>
      </div>
      <div class="operate">
        <template v-if="editFlag">
          <el-button
            type="text"
            icon="icon-ccui-save"
            v-preventReClick
            @click="dealBidReportSave"
            >保存</el-button
          >
          <!-- <el-button
            type="text"
            icon="icon-ccui-agree"
            v-preventReClick
            @click="dealBidReportSubmit"
            >提交确认</el-button
          > -->
          <el-button
            type="text"
            icon="icon-ccui-cancel"
            @click="editFlag = false"
            >取消</el-button
          >
        </template>
        <template v-else>
          <el-button type="text" icon="icon-ccui-edit" @click="editClick"
            >编辑</el-button
          >
          <!-- <el-button
            type="text"
            icon="icon-ccui-agree"
            v-if="form.reportStatus == 0 || form.reportStatus == 1"
            v-preventReClick
            @click="dealBidReportSubmit"
            >提交确认</el-button
          > -->
          <el-button
            type="text"
            v-preventReClick
            icon="icon-ccui-agree"
            @click="dealBidReportEffect"
            >评标报告生效</el-button
          >
          <el-button
            type="text"
            icon="icon-ccui-foresee"
            @click="prviewEvaluePrep"
            >预览评标报告</el-button
          >
          <el-button type="text" icon="icon-ccui-sharing-o" @click="reload()"
            >刷新</el-button
          >
        </template>
      </div>
      <evaluationResultDialog
        v-if="visible"
        :visible.sync="visible"
        :dialogData="dialogData"
        :key="'evaluationResultDialog' + new Date().getTime()"
      ></evaluationResultDialog>
    </div>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
import Cookies from "js-cookie";
import evaluationResultDialog from "@/app/sourcingFlow/components/evaluationResultDialog";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import {
  qryBidReportDetailApi,
  qryFileinfoListApi,
  dealBidReportSaveApi,
  qryBidReportExpertConfirmListApi,
  qryBidReportRecommendListApi,
  dealBidReportSubmitApi,
  dealBidReportEffectApi,
  qryBidEvaProcessStatusApi,
  listPurchaseSchemePackageApi,
  batchDownloadEvaReport,
  uploadFileCheck,
  getReportFileUrl
} from "@/app/sourcingFlow/api/expertEvaluation.js";
// import { savefile } from "@/app/sourcingFlow/api/expertEvaluation.js";
import bidEvaProcessStatus from "@/app/sourcingFlow/mixins/getBidEvaProcessStatus.js";
import { Loading } from "ccui";
import { addUrlPerFix, getPreviewUrl } from "@/basa/utils";

export default {
  name: "bidEvaluationReportPreparation",
  components: {
    breadcrumbSourcing,
    evaluationResultDialog
  },
  mixins: [bidEvaProcessStatus],
  inject: ["reload"],
  data() {
    return {
      BigNumber: BigNumber,
      baojiaName: "报价（" + sessionStorage.getItem("moneyTypeName") + "）含税",
      visible: false,
      dialogData: {},
      formData: {
        agentId: this.$router.history.current.query.a
      },
      breadcrumbData: {
        titname: "评标报告编制",
        status: JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
          .billStatusName
      },
      editFlag:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ==
        "0"
          ? true
          : false, // 是否是编辑状态
      // 080701  0  编辑中 080701  1  确认中 080701  2  确认结束 080701  3  已生效
      labelType:
        JSON.parse(sessionStorage.getItem("bidEvaProcessStatus")).billStatus ===
        "0"
          ? "editorial"
          : JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
              .billStatus === "1"
          ? "confirmation"
          : JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
              .billStatus === "3"
          ? "executed"
          : "confirmed",
      form: {},
      active: "1",
      expertTableData: [], // 专家确认记录
      recommendationTableData: [], // 推荐表数据
      bidEvaluationReportTableData: [], // 评标报告手签版
      otherFileTableData: [], // 其他附件
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL + "/apis/bid/oss/uploadFilePersNew"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      bidReportId: "",
      FileInfoBOs: [], // 新上传的附件
      evaMethod: JSON.parse(sessionStorage.getItem("bidEvaPrepareDetailData"))
        .evaMethod, // 评标法 101：最低价评标法  102：综合评标法
      labelShow: true,
      loading: false,
      subPackageFlag: true,
      uploadLoading: null,
      purchaseType: "",
      keepEditFlag: false,
      confirmStatus: true, //专家是否已全部确认
      roudMax: ""
    };
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (sessionStorage.getItem("keepEditFlag")) {
      this.keepEditFlag = sessionStorage.getItem("keepEditFlag");
    }
    this.getData();
  },
  created() {
    this.getSubPackageFlag();
  },
  methods: {
    getSubPackageFlag() {
      listPurchaseSchemePackageApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag =
          res.data.data.subPackageFlag == "1" ? true : false;
      });
    },
    getReportFileUrl() {
      getReportFileUrl({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      })
        .then(res => {
          if (!res.data.data) {
            this.$message({
              message: "评标报告正在生成中",
              type: "warning"
            });
            return;
          }
          window.open(res.data.data);
        })
        .catch(res => {});
    },
    goDetail(row) {
      this.visible = true;
      // row.packId = row.packId;
      row.schemeId = JSON.parse(
        sessionStorage.getItem("expertSourceData")
      ).schemeId;
      // row.sumScoreType =
      //   row.busiSumScore && row.techSumScore
      //     ? 2
      //     : row.busiSumScore && !row.techSumScore
      //     ? 1
      //     : 2;
      row.sumScoreType = 2;
      this.dialogData = row;
    },
    toAI(row) {
      let baseUrl = "http://47.108.13.132:8102";
      if (window.location.host.indexOf("local") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("test01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("uat01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else {
        baseUrl = "https://aimarket.iccec.cn";
      }
      window.open(
        baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=false&step=1&token=" +
          sessionStorage.getItem("AItoken") +
          "&tech=false",
        "_blank"
      );
    },

    addRedStar(h, { column }) {
      // if (this.check) {
      //   return [
      //     h("span", { style: "color: #d3142b" }, "*"),
      //     h("span", " " + column.label)
      //   ];
      // } else {
      //   return [h("span", " " + column.label)];
      // }
      return [
        h("span", { style: "color: #d3142b" }, "*"),
        h("span", " " + column.label)
      ];
    },
    init() {
      this.getData();
      // this.reload();
    },
    getData() {
      qryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        purStep: this.$router.history.current.query.menuKey
      }).then(res => {
        this.$set(this, "labelShow", false);
        if (this.keepEditFlag) {
          this.$set(this, "editFlag", false);
        } else {
          this.$set(
            this,
            "editFlag",
            res.data.data.billStatus == "0" ? true : false
          );
        }
        this.labelType =
          res.data.data.billStatus === "0"
            ? "editorial"
            : res.data.data.billStatus === "1"
            ? "confirmation"
            : res.data.data.billStatus === "3"
            ? "executed"
            : "confirmed";
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
        this.$set(
          this.breadcrumbData,
          "status",
          JSON.parse(sessionStorage.getItem("bidEvaProcessStatus"))
            .billStatusName
        );
        this.$set(this, "active", "1");
        this.$set(this, "labelShow", true);
      });
      console.log(this.editFlag, "editFlag");
      // 查看详情
      qryBidReportDetailApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        this.form = res.data.data;
        this.bidReportId = res.data.data.bidReportId;
        // 其他附件
        qryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "0807",
          uploadPhase: "0807"
        }).then(res => {
          this.otherFileTableData = JSON.parse(JSON.stringify(res.data.data));
        });
        // 手签版
        qryFileinfoListApi({
          parentBillId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          billId: this.bidReportId,
          billType: "080701",
          uploadPhase: "080701"
        }).then(res => {
          this.bidEvaluationReportTableData = res.data.data;
        });
      });
      // 专家确认列表
      qryBidReportExpertConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidReportId: this.bidReportId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        if (res.data.code === "0") {
          let list = {};
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          // 获取最新一轮
          if (res.data?.data?.rows?.length) {
            const maxRound = res.data.data.rows.reduce(
              (max, item) => Math.max(max, item.round),
              0
            );
            res.data.data.roundMax = maxRound;
            this.roudMax = res.data.data.roundMax;
          }
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                reportConfirmId: itemtow.reportConfirmId,
                joinExpertId: itemtow.joinExpertId,
                expertName: itemtow.expertName,
                round: itemtow.round,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: itemtow.confirmOpinion,
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                devspan: devspan
              };
              newData.push(obj);
            });
          });
          this.expertTableData = newData;
          if (newData.length > 0) {
            newData.forEach(item => {
              if (
                item.confirmStatus === "0" &&
                res.data.data.roundMax == item.round
              ) {
                this.confirmStatus = false;
              }
            });
          }
        }
      });
      // 推荐表
      qryBidReportRecommendListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        if (res.data.code === "0") {
          let data = [];
          let devspan = 0;
          let id = 0;
          res.data.data.forEach((item, index) => {
            if (index > 0) {
              devspan += res.data.data[index - 1].sscBidReportSupBOS.length;
            }
            if (res.data.data[0].packName) {
              id++;
            } else {
              id = 0;
            }
            if (item.sscBidReportSupBOS && item.sscBidReportSupBOS.length > 0) {
              item.sscBidReportSupBOS.forEach((itemtow, indextow) => {
                if (!res.data.data[0].packName) {
                  id = data.length + 1;
                }
                let obj = {
                  id: id,
                  packName: item.packName,
                  packId: item.packId,
                  scoreSumId: itemtow.scoreSumId,
                  supCode: itemtow.supCode,
                  supName: itemtow.supName,
                  techSumScore: itemtow.techSumScore,
                  busiSumScore: itemtow.busiSumScore,
                  sumScore: itemtow.sumScore,
                  aiSumScore: itemtow.aiSumScore,
                  taskId: itemtow.taskId,
                  priceAmount: itemtow.priceAmount,
                  recommendFlag: itemtow.recommendFlag,
                  recommendFlagStr:
                    itemtow.recommendFlag == "1"
                      ? "推荐"
                      : itemtow.recommendFlag == "0"
                      ? "不推荐"
                      : "-",
                  reason: itemtow.reason,
                  rowspan: item.sscBidReportSupBOS.length,
                  devspan: devspan
                };
                data.push(obj);
              });
            }
          });

          this.recommendationTableData = data;
        }
      });
    },
    // 推荐表
    objectSpanMethodRecommendation({ row, column, rowIndex, columnIndex }) {
      if (this.subPackageFlag) {
        if (columnIndex < 2) {
          if ((rowIndex - row.devspan) % row.rowspan === 0) {
            return {
              rowspan: row.rowspan,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }
    },
    //专家确认列表
    objectSpanMethodResult({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 1) {
        if ((rowIndex - row.devspan) % row.rowspan === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    deleteFile(index, type) {
      // 0:评标报告手签版 1：其他附件
      if (type == 0) {
        this.bidEvaluationReportTableData.splice(index, 1);
      } else {
        this.otherFileTableData.splice(index, 1);
      }
    },
    async uploadSuccess(res, file, fileList) {
      this.uploadLoading.close();
      let fileData = res.data[0];
      fileData.downloadUrl = fileData.ossUrl;
      // await savefile({ uploadIds: fileData.uploadId }).then(obj => {
      //   fileData.downloadUrl = obj.data.data.fileInfoList[0].ossUrl;
      // });
      let obj = {
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileDesc: "",
        fileSumm: "",
        createTime: fileData.createTime,
        uploadTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId,
        billType: "080701"
      };
      this.bidEvaluationReportTableData.push(obj);
      this.FileInfoBOs.push(obj);
    },
    // 上传类型错误
    handleErrorReport(res, file) {
      this.uploadLoading.close();
      this.loading = false;
      console.log(res);
    },
    // 只能上传一个手牵版
    async beforeUpload(file) {
      return new Promise(async (resolve, reject) => {
        this.uploadLoading = Loading.service({
          lock: true,
          text: "上传中,请稍等...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.2)",
          customClass: "ccui-custom-loading"
        });
        console.log(file);
        if (this.bidEvaluationReportTableData.length > 0) {
          this.$message({
            message:
              "因为评标报告手签附件只有一个，如果您要上传新手签附件请先删除所有手签列表附件！",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.uploadLoading.close();
          reject(false);
          return;
        }
        // 只能上传pdf、doc、docx
        let name = file.name;
        let type = name.substring(name.lastIndexOf(".") + 1);
        if (!(type.includes("docx") || type.includes("pdf"))) {
          this.$message({
            message: "评标报告手签只能上传docx格式文档或pdf文档！",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          this.loading = false;
          this.uploadLoading.close();
          reject(false);
          return;
        }
        // 新增后端校验文件
        try {
          const formData = new FormData();
          formData.append("file", file);
          await uploadFileCheck(formData);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          this.loading = false;
          this.uploadLoading.close();
        }
        return;
      });
    },
    uploadChange(file, fileList) {
      this.loading = !this.loading;
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading.close();
    },
    beforeAvatarUpload(file) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
    },
    async uploadOtherFileSuccess(res, file, fileList) {
      let fileData = res.data[0];
      fileData.downloadUrl = fileData.ossUrl;
      // await savefile({ uploadIds: fileData.uploadId }).then(obj => {
      //   fileData.downloadUrl = obj.data.data.fileInfoList[0].ossUrl;
      // });
      this.uploadLoading.close();
      let obj = {
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileDesc: "",
        fileSumm: "",
        createTime: fileData.createTime,
        uploadTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId,
        billType: "0807"
      };
      this.otherFileTableData.push(obj);
      this.FileInfoBOs.push(obj);
    },
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    // 保存
    async dealBidReportSave() {
      let sscBidReportRecommendBOS = [];
      this.recommendationTableData.forEach((item, index) => {
        if (item.recommendFlag == "0" && !item.reason) {
          this.$message({
            message: "第" + (index + 1) + "行，选择不推荐，说明理由必填",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          throw Error();
        }
        if (item.recommendFlag === "" || item.recommendFlag === undefined) {
          this.$message({
            message: "第" + (index + 1) + "行，请选择是否推荐",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          throw Error();
        }
        let obj = {};
        obj.scoreSumId = item.scoreSumId;
        obj.packId = item.packId;
        obj.packName = item.packName;
        obj.supCode = item.supCode;
        obj.supName = item.supName;
        obj.Flag = item.recommendFlag;
        obj.reason = item.reason;
        sscBidReportRecommendBOS.push(obj);
      });
      // let fileinfoIds = [];
      let fileDatas = [];
      // let fileFlag = true;
      if (this.bidEvaluationReportTableData.length > 0) {
        this.bidEvaluationReportTableData.forEach(item => {
          // if (item.fileinfoId) {
          //   fileinfoIds.push(item.fileinfoId);
          // } else {
          // if (!item.fileSumm) {
          //   fileFlag = false;
          // }
          fileDatas.push(item);
          // }
        });

        this.otherFileTableData.forEach(item => {
          // if (item.fileinfoId) {
          //   fileinfoIds.push(item.fileinfoId);
          // } else {
          fileDatas.push(item);
          // }
        });
        // if (!fileFlag) {
        //   this.$message({
        //     message: "评标报告手签版附件说明必填！",
        //     type: "error",
        //     duration: 3000,
        //     showClose: true,
        //     ccuiCustom: true
        //   });
        //   return;
        // }

        // 提示“还有专家未提交确认结果，是再次提交确认”
        let isConfirm = true;
        if (!this.confirmStatus) {
          isConfirm = await this.$confirm(
            // "还有专家未提交确认结果，是否再次提交确认？",
            "还有专家未提交确认结果，不允许保存！",
            "提示",
            {
              // distinguishCancelAndClose: true,
              // confirmButtonText: "确定",
              // cancelButtonText: "取消",
              // customClass: "ccui-message-box-custom"
              // distinguishCancelAndClose: true,
              showCancelButton: false,
              confirmButtonText: "确定",
              customClass: "ccui-message-box-custom"
            }
          ).then(() => {
            return false;
          });
          // .catch(() => {
          //   return false;
          // });
        }
        if (!isConfirm) {
          return;
        }

        // 新增：只有已提交确认（确认中状态）后再点击“保存”，才弹框二次确认；未提交确认时保存保持原逻辑
        let billStatus = JSON.parse(
          sessionStorage.getItem("bidEvaProcessStatus")
        ).billStatus;
        if (billStatus === "1") {
          let canSave = await this.$confirm(
            "保存后需要发起新的确认，是否保存？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              customClass: "ccui-message-box-custom"
            }
          )
            .then(() => true)
            .catch(() => false);
          if (!canSave) {
            return;
          }
        }

        let param = {
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          bidReportId: this.bidReportId,
          projectName: this.form.projectName,
          projectCode: this.form.projectCode,
          agentIdNum: this.form.agentId,
          agentUserId: this.form.agentUserId,
          agentName: this.form.agentName,
          isShowLoading: true,
          textInfo: this.form.textInfo,
          sscBidReportRecommendBOS: sscBidReportRecommendBOS,
          FileInfoBOs: fileDatas,
          fileinfoIds: []
        };
        dealBidReportSaveApi(param).then(res => {
          if (res.data.code == "0") {
            this.$message({
              message: "评标报告保存成功！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            this.keepEditFlag = true;
            sessionStorage.setItem("keepEditFlag", this.keepEditFlag);
            this.init();
          }
        });
      } else {
        this.$message({
          message: "评标报告手签版未上传！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 提交确认
    async dealBidReportSubmit() {
      let sscBidReportRecommendBOS = [];
      this.recommendationTableData.forEach((item, index) => {
        if (item.recommendFlag == "0" && !item.reason) {
          this.$message({
            message: "第" + (index + 1) + "行，选择不推荐，说明理由必填",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          throw Error();
        }
        if (item.recommendFlag === "" || item.recommendFlag === undefined) {
          this.$message({
            message: "第" + (index + 1) + "行，请选择是否推荐",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          throw Error();
        }
        let obj = {};
        obj.scoreSumId = item.scoreSumId;
        obj.packId = item.packId;
        obj.packName = item.packName;
        obj.supCode = item.supCode;
        obj.supName = item.supName;
        obj.Flag = item.recommendFlag;
        obj.reason = item.reason;
        sscBidReportRecommendBOS.push(obj);
      });
      let fileDatas = [];
      // let fileFlag = true;
      // 手签版应该必须上传的，
      if (this.bidEvaluationReportTableData.length > 0) {
        this.bidEvaluationReportTableData.forEach(item => {
          // if (item.fileinfoId) {
          //   fileinfoIds.push(item.fileinfoId);
          // } else {
          // if (!item.fileSumm) {
          //   fileFlag = false;
          // }
          fileDatas.push(item);
          // }
        });
        this.otherFileTableData.forEach(item => {
          // if (item.fileinfoId) {
          //   fileinfoIds.push(item.fileinfoId);
          // } else {
          fileDatas.push(item);
          // }
        });
        // if (!fileFlag) {
        //   this.$message({
        //     message: "评标报告手签版附件说明必填！",
        //     type: "error",
        //     duration: 3000,
        //     showClose: true,
        //     ccuiCustom: true
        //   });
        //   return;
        // }

        // 提示“还有专家未提交确认结果，是再次提交确认”
        let isConfirm = true;
        if (!this.confirmStatus) {
          isConfirm = await this.$confirm(
            // "还有专家未提交确认结果，是否再次提交确认？",
            "还有专家未提交确认结果，不允许提交确认！",
            "提示",
            {
              // distinguishCancelAndClose: true,
              // confirmButtonText: "确定",
              // cancelButtonText: "取消",
              // customClass: "ccui-message-box-custom"
              // distinguishCancelAndClose: true,
              showCancelButton: false,
              confirmButtonText: "确定",
              customClass: "ccui-message-box-custom"
            }
          ).then(() => {
            return false;
          });
          // .catch(() => {
          //   return false;
          // });
        }
        if (!isConfirm) {
          return;
        }

        let param = {
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          bidReportId: this.bidReportId,
          projectName: this.form.projectName,
          projectCode: this.form.projectCode,
          agentIdNum: this.form.agentId,
          agentUserId: this.form.agentUserId,
          agentName: this.form.agentName,
          textInfo: this.form.textInfo,
          sscBidReportRecommendBOS: sscBidReportRecommendBOS,
          FileInfoBOs: fileDatas,
          fileinfoIds: []
        };
        dealBidReportSubmitApi(param).then(res => {
          if (res.data.code == "0") {
            this.init();
            this.$message({
              message: "评标报告提交确认成功！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        });
      } else {
        this.$message({
          message: "评标报告手签版未上传！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 预览评标报告
    prviewEvaluePrep() {
      batchDownloadEvaReport({
        fileUrl: this.bidEvaluationReportTableData[0].fileUrl,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        fileName: this.bidEvaluationReportTableData[0].fileName
      }).then(res => {
        getPreviewUrl(res.data.data.uploadId);
        // window.open(previewSrc);
      });
      // this.bidEvaluationReportTableData.forEach(row => {
      //   let openUrl = document.createElement("a");
      //   openUrl.style.display = "none";
      //   openUrl.href = `${addUrlPerFix(
      //     process.env.VUE_APP_BASE_URL
      //   )}/apis/bid/oss/downloadByUploadId?fileUrl=${
      //     row.fileUrl
      //   }&fileName=${encodeURIComponent(row.fileName)}`;
      //   openUrl.setAttribute("download", row.fileName);
      //   document.body.appendChild(openUrl);
      //   openUrl.click();
      // });
    },
    editClick() {
      this.editFlag = true;
      this.keepEditFlag = false;
      this.$nextTick(() => {
        this.active = "1";
      });
    },
    // 生效
    async dealBidReportEffect() {
      if (
        (this.form.reportStatus == 0 || this.form.reportStatus == 1) &&
        !this.expertTableData.length
      ) {
        this.$message({
          message: "请先提交确认！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return;
      }
      // 手签版应该必须上传的，
      // 提交确认的时候，其他专家没确认的时候，应该有另外几个专家没进行确认的提示
      if (this.bidEvaluationReportTableData.length > 0) {
        // 校验专家确认状态：只要有任意一位专家未确认，直接拦截
        await this.qryExpertConfirmList();
        let unconfirmedExperts = [];
        this.expertTableData.forEach(item => {
          if (item.confirmStatus === "0" && item.round == this.roudMax) {
            unconfirmedExperts.push(item.expertName);
          }
        });

        if (unconfirmedExperts.length > 0) {
          this.$message({
            message: `专家${unconfirmedExperts.join(
              "、"
            )}尚未确认，不允许生效！`,
            type: "error",
            duration: 5000,
            showClose: true,
            ccuiCustom: true
          });
          this.$set(this, "active", "4");
          return;
        }

        dealBidReportEffectApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          bidReportId: this.bidReportId,
          isShowLoading: true,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId
        }).then(res => {
          if (res.data.code == "0") {
            // 评标报告已生效，评标室将自动关闭，评标状态为评标结束
            this.$message({
              message: "评标室已关闭！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            setTimeout(() => {
              window.parent.postMessage(false, "*");
            }, 500);
          }
        });
      } else {
        this.$message({
          message: "评标报告手签版未上传！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    qryExpertConfirmList() {
      // 专家确认列表
      qryBidReportExpertConfirmListApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        bidReportId: this.bidReportId,
        pageNo: 1,
        pageSize: 100
      }).then(res => {
        if (res.data.code === "0") {
          // 每次查询先重置，避免历史状态残留导致误拦截
          this.confirmStatus = true;
          let list = {};
          res.data.data.rows.map(item => {
            list[item.round] = list[item.round] || [];
            list[item.round].push(item);
          });
          // 获取最新一轮
          if (res.data?.data?.rows?.length) {
            const maxRound = res.data.data.rows.reduce(
              (max, item) => Math.max(max, item.round),
              0
            );
            res.data.data.roundMax = maxRound;
            this.roudMax = res.data.data.roundMax;
          }
          let arr = [];
          Object.keys(list).map(key => {
            arr.push(list[key]);
          });
          arr.sort(function(a, b) {
            return a[0].round - b[0].round;
          });
          let devspan = 0;
          let newData = [];
          arr.forEach((item, index) => {
            if (index > 0) {
              devspan += arr[index - 1].length;
            }
            item.forEach((itemtow, indextow) => {
              let obj = {
                id: indextow + 1,
                reportConfirmId: itemtow.reportConfirmId,
                joinExpertId: itemtow.joinExpertId,
                expertName: itemtow.expertName,
                round: itemtow.round,
                confirmResult: itemtow.confirmResult,
                confirmResultStr: itemtow.confirmResultStr,
                confirmOpinion: itemtow.confirmOpinion,
                confirmTime: itemtow.confirmTime,
                confirmStatus: itemtow.confirmStatus,
                confirmStatusStr: itemtow.confirmStatusStr,
                rowspan: item.length,
                devspan: devspan
              };
              newData.push(obj);
            });
          });
          this.expertTableData = newData;
          if (newData.length > 0) {
            newData.forEach(item => {
              if (
                item.confirmStatus === "0" &&
                res.data.data.roundMax == item.round
              ) {
                this.confirmStatus = false;
              }
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fr {
  float: right;
}
.clear {
  clear: both;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-tabs__customize > .el-tabs__header {
  margin-bottom: 20px !important;
  padding-top: 20px !important;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
.link-color {
  color: #0089ef;
}
.pdf-btn {
  text-align: right;
  margin-right: 120px;
}
.sure-btn {
  margin-right: 0;
  border-color: #0089ef;
  color: #ffffff;
  background: #0099f1;
}
</style>
